import app from 'Cloud/Application/app';
import MicroEvent from 'mrg-microevent';

import DropArea from './Upload/tools/dnd/DropArea';
import UploadController from './Upload/UploadController';
import uploadLog from './Upload/uploadLog';

const uploadController = new UploadController();

export const setInputs = function (inputs, disableDrop = false) {
    inputs?.addEventListener('change', function (event) {
        if (disableDrop && event.type === DropArea.EVENT_DROP) {
            return;
        }

        uploadController.handleEvent(event);
    });
};

export default function initAndImplementOldInterface() {
    app.upload = {
        _controller: uploadController,
        _log: uploadLog,

        cancelLoadFile: function (id) {
            uploadController._onCancel({}, { id });
        },

        onInputChange: function (event, descriptorOptions = {}) {
            uploadController.onInputChange(event, descriptorOptions);
        },

        onDrop: function (data, descriptorOptions = {}) {
            uploadController.onDrop(data, descriptorOptions);
        },

        allCancelLoadFile: function () {
            uploadController._onCancelAll();
        },

        closeOldUploader: function () {
            uploadController._onClose();
        },

        isActive: function () {
            return uploadController.isActive();
        },

        isDragAndDropable: function () {
            return DropArea.isSupported();
        },

        disableDropArea: function () {
            const dropArea = uploadController.dropArea();

            if (dropArea) {
                dropArea.disableDropArea();
            }
        },

        enableDropArea: function () {
            const dropArea = uploadController.dropArea();

            if (dropArea) {
                dropArea.enableDropArea();
            }
        },

        clearUploadedQueue: function () {
            uploadController.clearUploadedQueue();
        },

        setInputs,
    };

    MicroEvent.mixin(app.upload);

    window.addEventListener('beforeunload', function (event) {
        if (uploadController.isActive()) {
            const message = 'Если покинуть страницу сейчас, Ваш файл не будет загружен!';

            event.returnValue = message;

            return message;
        }
    });
}
